import _ from 'lodash';
/**
 * @type {Object}
 * @property {array}  errorLog   error log
 */
const initialState = {
    errorLog: [],
    errorLogHistory: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerErrorLog = (state = initialState, action) => {
    const newState = { ...state }
    var { data } = action;

    switch (action.type) {
        case 'FETCH_ERROR_LOG':
            var { data } = action;
            newState.errorLog = data;
            break;

        case 'FETCH_ERROR_LOG_HISTORY':
            var { data } = action;
            newState.errorLogHistory = data;
            break;
        default:
            break;
    }
    return newState;
}

export default reducerErrorLog;